export default function FieldSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="h-6 bg-gray-300 rounded-full"></div>
    </div>
  );
}
